import * as _ from "lodash";
import {QuoteWizardDefaultCustomViewController} from '../quoteWizardDefaultCustomView.controller';
import {LocationAggregate} from '../../../../models/models';

export class AddAnotherLocationController extends QuoteWizardDefaultCustomViewController {
    public addAnotherLocation: boolean;
    public chunkedLocations: LocationAggregate[][];

    protected activate(): void {
        super.activate();
        this.addAnotherLocation = false;
        this.chunkLocations();
    }

    public goNext(): void {
        this.validationService.setGlobalOptions({hideErrorUnderInputs: false});
        if (angular.isDefined(this.quoteWizardForm) && this.validationService.checkFormValidity(this.quoteWizardForm) === false) {
            return;
        }

        if (this.addAnotherLocation) {
            this.stateService.addAnotherLocation();
            //this looks wrong, but since this screen is past the location section, going back
            //will step back to the last child node in the location prior to the one that was just added
            //then the goNext will take it to the first node of the new location 
            this.navigationService.goBack();
        }

        this.navigationService.goNext();
    }

    public delete(location: LocationAggregate): void {
        if (this.stateService.viewModel.clientStateContext.submissionRequest.locations.length > 1) {
            this.stateService.viewModel.clientStateContext.submissionRequest.locations.splice(
                this.stateService.viewModel.clientStateContext.submissionRequest.locations.indexOf(location), 1);

            this.chunkLocations();

            this.stateService.saveState();
        }
    }

    private chunkLocations() {
        this.chunkedLocations = _.chunk(this.stateService.viewModel.clientStateContext.submissionRequest.locations, 2);
    }
}